export default __webpack_public_path__ + "static/media/wallpaper.3ad57c41.jpg";